"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumFeature = void 0;
/**
 * The Feature that the event is related to. For example, if the user is on the dashboard and click on a message, we would set the Feature as \'Messaging\' and the ScreenName as \'Dashboard\'.
 * @export
 * @enum {string}
 */
exports.EnumFeature = {
    CarePlan: 'CarePlan',
    ClinicalProgram: 'ClinicalProgram',
    Conditions: 'Conditions',
    Consent: 'Consent',
    Discover: 'Discover',
    Health: 'Health',
    Home: 'Home',
    LoginRegistration: 'LoginRegistration',
    LossOfSponsorship: 'LossOfSponsorship',
    Profile: 'Profile',
    Search: 'Search',
    StandaloneScreening: 'StandaloneScreening',
    MentalHealthSurvey: 'MentalHealthSurvey',
    FriendsAndFamily: 'FriendsAndFamily',
    UkCanada: 'UKCanada',
    Error: 'Error',
    CrisisLifeline: 'CrisisLifeline',
    Debug: 'Debug',
    FtueSurvey: 'FtueSurvey',
    NotMapped: 'NotMapped',
    Notifications: 'Notifications',
    Onboarding: 'Onboarding',
    Programs: 'Programs',
};
//# sourceMappingURL=enum-feature.js.map